import { Injectable } from '@angular/core';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';
import type { HikvisionCameraEventPageInterface } from '@zaoblako/shared/modules/cctv/dtos/hikvision-camera-event/hikvision-camera-event-page.dto';
import type { HikvisionCameraEventQueryInterface } from '@zaoblako/shared/modules/cctv/dtos/hikvision-camera-event/hikvision-camera-event-query.dto';
import type { HikvisionCameraFindManyQueryInterface } from '@zaoblako/shared/modules/cctv/dtos/hikvision-camera/hikvision-camera-find-many-query.dto';
import type { HikvisionCameraPageInterface } from '@zaoblako/shared/modules/cctv/dtos/hikvision-camera/hikvision-camera-page.dto';
import type { HikvisionCameraFindInterface } from '@zaoblako/shared/modules/cctv/dtos/hikvision-camera/hikvision-camera-find.dto';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';

@Injectable({
  providedIn: 'root'
})
export class HikvisionCameraService extends BaseService {
  protected baseUrl = '/cctv/hikvision/camera';

  public findMany(queryParams?: HikvisionCameraFindManyQueryInterface): Observable<HikvisionCameraPageInterface> {
    return this.http.get<HikvisionCameraPageInterface>(this.baseUrl, {
      params: queryParams ? this.objectToHttpParams(queryParams): {}
    });
  }

  public restoreOne(id: number): Observable<HikvisionCameraFindInterface> {
    return this.http.post<HikvisionCameraFindInterface>(`${this.baseUrl}/${id}/restore`, null);
  }

  public getHistoryForOne(id: number, queryParams?: PaginationQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HikvisionCameraPageInterface>(`${this.baseUrl}/${id}/history`, {
      params: queryParams ? this.objectToHttpParams(queryParams): {}
    });
  }

  public getImageForOne(id: number): Observable<BlobPart> {
    return this.http.get<BlobPart>(`${this.baseUrl}/${id}/image`, {
      responseType: 'arraybuffer' as any
    });
  }

  public findEvents(
    queryParams: HikvisionCameraEventQueryInterface
  ): Observable<HikvisionCameraEventPageInterface> {
    return this.http.get<HikvisionCameraEventPageInterface>(`${this.baseUrl}-event`, {
      params: this.objectToHttpParams(queryParams)
    });
  }
}
